import React, { useRef, useState } from "react";
import Modal from "react-responsive-modal";
import { useDispatch } from "react-redux";
import {modifySimulate} from '../Store/improveRate/actions';


const ModalImproveRate = ({ open,item,close }) => {
  const buttonRef = useRef("");
  const [error, setError] = useState({
    message: "",
    status: true,
  });
  const dispatch = useDispatch();

  const dipatchImproveRate = ()=> {
    const { value } = buttonRef.current;
    modifySimulate(dispatch,item.idSimulacion,value) ;
  } ;


  const handle = (e) => {
    const { value } = buttonRef.current;
    if (value.length === 0 || parseFloat(value) < 0) {
      setError({ message: "tasa incorrecta", status: true });
    } else {
      setError({
        message: "",
        status: false,
      });
    }
  };

  return (
    <Modal
      open={open}
      closeOnEsc={false}
      onClose={close}
      closeOnOverlayClick={false}
      center
      classNames={{ modalGeneralPoliticas: "modalGeneralPoliticas" }}
    >
      <div className="boxModal loginModal">
        <p className="tituloModal">Ingrese tasa a modificar</p>
        <input
          ref={buttonRef}
          placeholder="ingrese tasa"
          onChange={handle}
          type="number"
          min="0"
        />
        {error.status && <div style={{textAlign:'left',width:'100%'}}>{error.message}</div>}
        <div className="boxModal__buttons">
          <button
            className={`button-register ${error.status && "disabled"}`}
           onClick={dipatchImproveRate}
            disabled={error.status}
          >
            modificar
          </button>
          <button
            className='button-signOut'
            style={{marginLeft:'2px',marginRight:'0px'}}
           onClick={close}
          >
            cerrar
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalImproveRate;
